<template>
  <ModelPop slot="model-slot">
    <div class="model-content">
      <div class="content-content">{{$t('message.whether')}}</div>
      <!--底部按钮-->
      <div class="btn-button">
        <el-button type="primary" @click="clickBtn">{{$t('message.zfsuccess')}}</el-button>
        <el-button @click="clickBtn">{{$t('message.zfdestruction')}}</el-button>
      </div>
    </div>
  </ModelPop>
</template>

<script>
  import ModelPop from './ModelPop';

  export default {
    name: "PayOkConfirm",
    components:{ModelPop},
    methods:{
      clickBtn(){
        this.$emit('click-emit-reload') ;
      }
    }
  }
</script>

<style scoped>
  /* model  */
  .model-content {
    width: 400px;
    height: 150px;
    box-shadow: 0 0 20px 2px #999999;
    border-radius: 5px;
    background: #FFFFFF;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .content-content {
    flex: 1;
    font-size: 20px;
    line-height: 80px;
  }

  .btn-button {
    margin: 10px 20px 20px 0;
    display: flex;
    justify-content: flex-end;
  }
</style>



// WEBPACK FOOTER //
// src/components/assembly/PayOkConfirm.vue